export const APPS_FLYER_URL = 'https://websdk.appsflyer.com';
export const MAX_LOAD_ATTEMPTS = 10;
export const LOAD_ATTEMPT_TIMEOUT_MS = 1000;
